import Repository from '../axios'

export default {
  getRmSettings() {
    return Repository.get(`/admin/system_setting/raw-material-settings`)
  },
  updateRmSettings(payload) {
    return Repository.post(`admin/system_setting/raw-material-settings`, payload)
  },
};
